module.exports = __webpack_public_path__ + "index/img/cdk_header.6ebf749d.png";